<div class="container">
  <h1>Server Error</h1>
  <br />

  <p>An error has occurred with the connection to the server. Please try again later.</p>

  <button class="okBtn" mat-button mat-raised-button type="button" (click)="back()" color="primary">
    Ok
  </button>